module.exports = __webpack_public_path__ + "img/image5.3fe9f931.png";